module.exports = __webpack_public_path__ + "img/2.02.thmb.c099711c.jpg";